import { CryptoTransaction } from "@models/transaction/crypto_transaction";

export class SecurityTokenTransaction extends CryptoTransaction {}
